import { useRef } from "react";
import ModalPop from "./ModalPop";
import useDeviceType from "../common/useDeviceType";

export default function About() {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  const isMobile = useDeviceType();

  return (
    <section
      id="about"
      className="relative w-full overflow-hidden bg-white py-14 md:py-20"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />

      <div className="mx-auto max-w-screen-lg px-4 md:px-8 tracking-[-0.1em]">
        {/* 상단 타이틀 */}
        <div className="text-center" data-aos="fade-up">
          <h3 className=" font-medium text-xl md:text-2xl">
            문의접수 3초 + 유선 상담 평균 3분
          </h3>
          <h2 className="gbold text-primary">
            3분&nbsp;3초만에 해결방법을&nbsp;알려드립니다
          </h2>
          <p className="mx-auto my-5 text-base md:text-lg">
            급한현장·복잡한 현장·타업체 실패현장 등등 다양한 현장들
            <br />
            하수코 솔루션에 문의주시면 최선의 해결책을 제시하여 빠르게
            해결해드립니다.
          </p>
        </div>

        {/* 카드 + 캐릭터 */}
        <div className="relative mt-10 md:mt-16" data-aos="fade-up">
          <div className="relative flex items-end">
            {/* 카드 */}
            <div className="relative z-10 w-full text-center lg:text-left rounded-3xl border border-primary bg-white p-6 shadow-[0_10px_40px_rgba(0,0,0,0.08)] md:p-10 lg:w-[72%]">
              <h3 className="gbold font-bold text-primary">
                많고 많은 하수구업체들 중
              </h3>
              <h3 className="gbold -mt-1 lg:-mt-4 text-secondary">
                하수코솔루션은 “&nbsp;해결&nbsp;”&nbsp;에&nbsp;집중하는
              </h3>
              <h2 className="manru font-extrabold text-secondary">
                해결전문 업체입니다
              </h2>
              <p className="mt-4 text-secondary md:text-lg lg:text-2xl">
                3분 3초만 투자하시면 해결됩니다!
              </p>

              {/* 버튼 */}
              <div className="lg:absolute mt-4 flex flex-wrap justify-center lg:justify-start gap-3 tracking-tight">
                <button
                  type="button"
                  onClick={() => (window.location.href = "tel:010-5762-2738")}
                  className="rounded-full bg-red px-5 pb-1 pt-1.5 text-sm text-point transition-transform hover:-translate-y-0.5 md:text-base"
                >
                  긴급출동 서비스 ▶
                </button>
                <button
                  type="button"
                  onClick={openfunc}
                  className="rounded-full bg-secondary px-5 pb-1 pt-1.5 text-sm text-white transition-transform hover:-translate-y-0.5 md:text-base"
                >
                  해결상담 서비스 ▶
                </button>
              </div>
            </div>

            {/* 캐릭터 (데스크톱 전용) */}
            <img
              src="/images/eventPc1.png"
              alt="하수코 솔루션 상담원"
              loading="lazy"
              decoding="async"
              className="pointer-events-none absolute -top-12 right-0 z-20 hidden w-full max-w-[400px] lg:block"
            />
          </div>
        </div>

        {/* 하단 배너 */}
        <div
          className="cursor-pointer overflow-hidden rounded-xl -mt-4 md:mt-12"
          onClick={() => (window.location.href = "tel:010-5762-2738")}
          data-aos="fade-up"
        >
          <img
            src={isMobile ? "/images/eventMo2.png" : "/images/eventPc2.png"}
            alt="고객님의 고민, 하수코 솔루션이 3분 30초만에 깔끔하게 해결해드리겠습니다."
            loading="lazy"
            decoding="async"
            className="w-full"
          />
        </div>
      </div>
    </section>
  );
}
